module.exports = __webpack_public_path__ + "img/magic-wand-01.ffd93d39.svg";